'use client';

import theme from '@/components/core/theme';
import { css } from '@linaria/core';

export const root = css`
  display: flex;
  flex-direction: column;
  font-weight: 700;
  font-size: 18px;
  gap: 0.125rem;
  min-width: 160px;
  align-items: center;
  @media screen and (width > ${theme.sizes.screens.md}) {
    align-items: flex-start;
  }
  img {
    max-width: 120px;
    @media screen and (width > ${theme.sizes.screens.md}) {
      align-items: 160px;
    }
  }
`;

export const value = css`
  font-size: 44px;
  line-height: 1em;
`;

export const total = css`
  font-weight: 400;
  color: ${theme.colors.neutral[4]};
`;
